module.exports = __webpack_public_path__ + "static/media/aws-lambda.75de55c8.svg";